import {
  FETCH_LOCAL_USERS_REQUEST,
  FETCH_LOCAL_USERS_SUCCESS,
  FETCH_LOCAL_USERS_ERROR,
  EDIT_LOCAL_USERS_REQUEST,
  EDIT_LOCAL_USERS_SUCCESS,
  EDIT_LOCAL_USERS_ERROR,
  DELETE_LOCAL_USERS_REQUEST,
  DELETE_LOCAL_USERS_SUCCESS,
  DELETE_LOCAL_USERS_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    error: null,
    isFetching: false,
  },
  edit: {
    record: {},
    error: null,
    isUpdating: false,
    updated: false,
    deleted: false,
  },
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_LOCAL_USERS_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }
    case FETCH_LOCAL_USERS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          records: action.payload,
          isFetching: false,
        },
      }
    case FETCH_LOCAL_USERS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.payload,
          isFetching: false,
        },
      }
    case EDIT_LOCAL_USERS_REQUEST:
    case DELETE_LOCAL_USERS_REQUEST:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: true,
        },
      }
    case EDIT_LOCAL_USERS_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          record: action.payload,
          error: null,
          updated: true,
          isUpdating: false,
        },
      }
    case EDIT_LOCAL_USERS_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          error: action.payload,
          updated: false,
          isUpdating: false,
        },
      }
    case DELETE_LOCAL_USERS_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          record: action.payload,
          error: null,
          deleted: true,
          isUpdating: false,
        },
      }
    case DELETE_LOCAL_USERS_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          error: action.payload,
          deleted: false,
          isUpdating: false,
        },
      }
    default:
      return {
        ...state,
      }
  }
}
